
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
      print: null
    }
  },
  computed: {
    ...mapGetters('invoice', ['printInvoice']),
    invoiceIdFromQuery() {
      return (
        this.$route &&
        this.$route.query &&
        this.$route.query.id
      )
      ? this.$route.query.id
      : null;
    },
  },
  methods: {
    ...mapActions('invoice', ['unsetPrintInvoiceMap']),
    setInvoiceForPrinting() {
      let data = null
      if (this.invoiceIdFromQuery) {
        data = this.printInvoice(this.invoiceIdFromQuery);
      }
      if (!data) {
        alert('Can not get the invoice to print, Please try again.')
        window.close();
      }

      this.print = _.cloneDeep(data)
    },
    removeInvoiceFromInvoicePrintMap() {
      if (this.invoiceIdFromQuery) {
        this.unsetPrintInvoiceMap(this.invoiceIdFromQuery)
      }
    }
  }
};
